import { useState, useEffect, useCallback } from "react";
import { API_BASE_URL } from "../config/api";
import { authHeader } from "./authHeader";

// ── useAlertCount ─────────────────────────────────
// Polls unread alert count every 30 seconds
// Used by sidebar and top bell icon

const useAlertCount = (enabled = true) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!enabled) {
      setUnreadCount(0);
      return;
    }
    try {
      const res  = await fetch(`${API_BASE_URL}/api/alerts/unread-count`, {
        headers: authHeader(),
      });
      const data = await res.json();
      if (res.ok) setUnreadCount(data.unreadCount || 0);
    } catch {}
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setUnreadCount(0);
      return undefined;
    }
    fetchCount();
    // Poll every 30 seconds for new alerts
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [enabled, fetchCount]);

  return { unreadCount, refreshCount: fetchCount };
};

export default useAlertCount;
